import { formatDateHuman, parseDateRaw } from "../date-utils";
export const weightIngressDtoFields = [{
        /*
          name: "protocol",
          title: "Macellazione",
          render: (record: IWeightIngressDTO) => record.slaughter.protocol
        }, {
        */
        name: "dailyNumber",
        title: "Num.",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.slaughter.dailyNumber
    }, {
        name: "slaughterDate",
        title: "Data",
        render: (record) => formatDateHuman(parseDateRaw(record.slaughter.slaughterDate))
    }, {
        name: "dailyProgressive",
        title: "Progressivo",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.slaughterItem.dailyProgressive
    }, {
        name: "srcCod317",
        title: "Cod.317",
        render: (record) => record.slaughter.srcCod317
    }, {
        name: "customerName",
        title: "Destinazione",
        render: (record) => record.customerName
    }, {
        name: "lotNumber",
        title: "Lotto",
        render: (record) => record.slaughterItem.lotNumber
        /*
        }, {
          name: "purposeDescription",
          title: "Scopo",
          render: (record: IWeightIngressDTO) => record.purposeDescription
        }, {
          name: "utilizationDescription",
          title: "Utilizzo",
          render: (record: IWeightIngressDTO) => record.utilizationDescription
        }, {
          name: "utilizationNotes",
          title: "Note Utilizzo",
          render: (record: IWeightIngressDTO) => record.slaughter.utilizationNotes
        }, {
          name: "srcProductTypeName",
          title: "Tipologia Ingresso",
          render: (record: IWeightIngressDTO) => record.srcProductTypeName
        }, {
          name: "dstProductTypeName",
          title: "Tipologia Uscita",
          render: (record: IWeightIngressDTO) => record.dstProductTypeName
      }, {
        name: "totQuantity",
        title: "N° Capi Totale",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record: IWeightIngressDTO) => record.totalItems
      }, {
        name: "workedItems",
        title: "N° Capi Immessi",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record: IWeightIngressDTO) => record.workedItems
      }, {
        name: "remainingItems",
        title: "N° Capi Rimanenti",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record: IWeightIngressDTO) => record.remainingItems
        */
    }, {
        name: "worked",
        title: "Immesso",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.slaughterItem.worked === 1 ? "check" : (record.slaughterItem.skipped === 1 ? "close" : "")}</i>`
    }, {
        name: "printed",
        title: "Stampato",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.slaughterItem.printed === 1 ? "check" : ""}</i>`
    }];
